import {
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import IntelliButton from "../components/IntelliButton";
import { userLogin, userRecovery } from "../services/redux/actions/common/auth";

import {
  IntelliToastMsg,
  typeToast,
} from "../components/common/IntelliToastMsg";
import ReCAPTCHA from "react-google-recaptcha";
import { keyRecaptcha } from "../config";
import i18next from "i18next";

export const itemsDocumentTypes = () => [
  { value: 1, label: i18next.t("General.typesDocument.1") },
  { value: 2, label: i18next.t("General.typesDocument.2") },
  { value: 3, label: i18next.t("General.typesDocument.3") },
  { value: 4, label: i18next.t("General.typesDocument.4") },
  { value: 5, label: i18next.t("General.typesDocument.5") },
  { value: 6, label: i18next.t("General.typesDocument.6") },
  { value: 7, label: i18next.t("General.typesDocument.7") },
];

const InputKeral = ({
  icon = "fas fa-user",
  value,
  placeholder = "placeholder",
  onChange = () => {},
  type = "text",
  onKeyPress,
}) => {
  return (
    <div className="input-keral">
      <div className="icon">
        <i className={icon} />
      </div>
      <div className="input">
        <input
          value={value}
          type={type}
          placeholder={placeholder}
          onChange={onChange}
          onKeyPress={onKeyPress}
        />
      </div>
    </div>
  );
};

const SelectKeral = ({
  icon = "fas fa-user",
  onChange,
  value,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <div className="input-keral">
      {/* <InputLabel id="label-keral">{placeholder}</InputLabel> */}
      <div className="icon">
        <i className={icon} />
      </div>
      <Select
        value={value}
        label={placeholder}
        onChange={onChange}
        labelId="label-keral"
        id="label-keral-id"
      >
        {itemsDocumentTypes().map((i) => {
          return (
            <MenuItem value={i.value} key={i.value}>
              {i.label}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

const LoginForm = (props) => {
  const [documentType, setDocumentType] = useState(1);
  const [documentNumber, setDocumentNumber] = useState("");

  const [keyState, setKeyState] = useState(null);

  const refNumberField = useRef(null);

  useEffect(() => {
    console.info({ refNumberField });
  }, [refNumberField]);
  const { t } = useTranslation();

  const handleLogin = () => {
    if (!documentType) {
      IntelliToastMsg({
        type: typeToast.info,
        title: t(`General.documentType`),
        text: `${t("Login.email")}: ${t(`FormErrors.if111`)}`,
      });
      return false;
    }
    if (!documentNumber) {
      IntelliToastMsg({
        type: typeToast.info,
        title: t(`General.titleSuccess`),
        text: `${t("General.document")}: ${t(`FormErrors.if111`)}`,
      });
      return false;
    }
    if (!!documentType && !!documentNumber) {
      props.userLogin({
        id_document_type: documentType,
        dui_person: documentNumber,
      });
    }
  };

  return (
    <div className="keral-login-form">
      <div className="keral-login-form__logo">
        <img
          src={
            "https://staticmyintelli.s3.amazonaws.com/keralty/LOGO_KERALTY.png"
          }
          alt={"icon4"}
        />
      </div>
      <div className="keral-login-form__text">
        <p>
          Te damos la bienvenida a nuestro software de agendamiento de puestos
          de trabajo. ¡Elige tu espacio de trabajo y vive una experiencia cálida
          y segura en nuestras sedes!
        </p>
      </div>
      <div className="keral-login-form__fields">
        <div className="field">
          <SelectKeral
            placeholder={t("General.documentType")}
            icon={"fas fa-id-card"}
            value={documentType}
            onChange={(e) => {
              setDocumentType(e.target.value);
            }}
          />
        </div>
        <div className="field">
          <InputKeral
            placeholder={t("General.document")}
            icon={"fas fa-lock-alt"}
            onChange={(e) => setDocumentNumber(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") handleLogin();
            }}
            value={documentNumber}
            type={"number"}
          />
        </div>
      </div>
      <div className="keral-login-form__button">
        <div className="button">
          <Button variant="contained" onClick={handleLogin}>
            {t("Login.login")}
          </Button>
        </div>
      </div>
      <div className="keral-login-form__rights">
        <div className="rigths">
          <span>Derechos reservados</span>
        </div>
        <div className="intelli-logo">
          <img
            src={
              "https://staticmyintelli.s3.amazonaws.com/intellinext_black.png"
            }
            alt="IntelliNextLogo"
          />
        </div>
      </div>
    </div>
  );
};

export default connect(({}) => ({}), { userLogin, userRecovery })(LoginForm);
